import { render, staticRenderFns } from "./ProfileMyFriends.vue?vue&type=template&id=431811c2&scoped=true&lang=pug&"
import script from "./ProfileMyFriends.vue?vue&type=script&lang=js&"
export * from "./ProfileMyFriends.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMyFriends.vue?vue&type=style&index=0&id=431811c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431811c2",
  null
  
)

export default component.exports